import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  smallcalendar: localStorage.getItem('smallcalendar')
    ? JSON.parse(localStorage.getItem('smallcalendar'))
    : null,
};

const smallcalendarSlice = createSlice({
  name: 'smallcalendar',
  initialState,
  reducers: {
    setSmallCalendar: (state, action) => {
      state.smallcalendar = action.payload;
      localStorage.setItem('smallcalendar', JSON.stringify(action.payload));
    },
  },
});

export const {setSmallCalendar } = smallcalendarSlice.actions;

export default smallcalendarSlice.reducer;
